import script from "./UserItem.vue?vue&type=script&setup=true&lang=js"
export * from "./UserItem.vue?vue&type=script&setup=true&lang=js"

import "./UserItem.vue?vue&type=style&index=0&id=0b077539&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b077539"]])

export default __exports__